module.exports = __webpack_public_path__ + "img/setting-window.16626058.svg";